import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Flex, Text } from "@chakra-ui/react";
import { BillingInterval, PlanType } from "sdk/types";
import { useTrialDiscount } from "~/MemberApp/hooks";

interface Props {
  billingInterval: BillingInterval;
  fullPrice: number;
  type: PlanType;
}

export const ChargesAtEndOfTrial: FC<Props> = ({
  billingInterval,
  fullPrice,
  type,
}) => {
  const { t } = useTranslation();
  const trialDiscount = useTrialDiscount();
  const actionStem = `planPayment.payment` as const;
  const price =
    (billingInterval == "1-month" &&
      trialDiscount &&
      trialDiscount[type].discountPrice) ||
    fullPrice;
  const chargeDate = trialDiscount?.endedAtShort || "";

  const showDisclaimer = trialDiscount && trialDiscount.discount;

  return (
    <Flex direction="column" gap={4}>
      <Flex direction="column" gap={2}>
        <Text variant="th-body3">{t(`${actionStem}.totalToday.label`)}</Text>
        <Text fontWeight="bold" variant="th-body1">
          {t(`${actionStem}.totalToday.amount`, { price: "0.00" })}
        </Text>
      </Flex>
      <Flex direction="column" gap={2}>
        <Text variant="th-body3">
          {t(`${actionStem}.totalAfterTrial.label`, { date: chargeDate })}
        </Text>
        <Text fontWeight="bold" variant="th-body1">
          {t(`${actionStem}.totalAfterTrial.amount`, { price })}
        </Text>
        <Text color="th.gray4" variant="th-body4">
          {t(`planPayment.billingInterval.${billingInterval}.renewal`)}
        </Text>
        {showDisclaimer && (
          <Text color="th.gray4" variant="th-body4">
            {t("planPayment.extend.discount.disclaimer", {
              amount: fullPrice,
            })}
          </Text>
        )}
      </Flex>
    </Flex>
  );
};
